var $ = require('jquery');
require('fg-frontend/third/highslide/highslide-full');

hs.lang.loadingText = 'Načítám...';
hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = '';
hs.align = 'center';
hs.dimmingOpacity = 0.9;
hs.onDimmerClick = function() {
 	return false;
};
// hs.init.container = hs.createElement('div', {
// 			className: 'highslide-container'
// 		}, {
// 			position: 'fixed',
// 			left: 0,
// 			top: 0,
// 			width: '100%',
// 			zIndex: hs.zIndexCounter,
// 			direction: 'ltr'
// 		},
// 		document.body,
// 		true
// );

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
hs.captionOverlay = { position  : 'below'};

hs.marginBottom = 90;
hs.marginLeft = 30;
hs.marginRight = 30;
hs.marginTop = 30;

if (window.innerWidth >= 992) {
	hs.marginBottom = 80;
	hs.marginLeft = 120;
	hs.marginRight = 120;
	hs.marginTop = 80;
};

hs.maxWidth = 1920;
hs.maxHeight = 1280;

/*
if (hs.registerOverlay) {
	if (window.innerWidth >= 992) {
		hs.registerOverlay({
			fade: 2,
			hideOnMouseOut: false,
			html: '<a class="btn btn--gray btn--icon highslide__close" href="javascript:" onclick="return hs.close(this)"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#close"></use></svg><span class="sr-only">Zavřít</span></a>',
			useOnHtml: true,
			position: 'top right',
			relativeTo: 'viewport'
		});
	} else {
		hs.registerOverlay({
			fade: 2,
			hideOnMouseOut: false,
			html: '<a class="btn btn--gray btn--icon highslide__close" href="javascript:" onclick="return hs.close(this)"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#close"></use></svg><span class="sr-only">Zavřít</span></a>',
			useOnHtml: true,
			position: 'bottom center',
			relativeTo: 'viewport'
		});
	}
}
*/

hs.Expander.prototype.onBeforeExpand = function (sender) {
	//jen pro obrazky

	if (sender.a.className.indexOf("hs-htmlExpand") < 0) {
		// dynamicka navigace mezi fotkami

		var arrowLeft = document.createElement('div');
		var arrowRight = document.createElement('div');
		var closeBtn = document.createElement('div');


		closeBtn.innerHTML = '<a class="btn btn--gray btn--icon highslide__close" href="javascript:" onclick="return hs.close(this)"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#close"></use></svg><span class="sr-only">Zavřít</span></a>';
		closeBtn.className = 'highslide__control-bar';

		if(sender.getAdjacentAnchor(-1)){
			arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide__control highslide__control--previous"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></a>';
			arrowLeft.className = 'highslide__control-bar';
		}
		if(sender.getAdjacentAnchor(1)){
			arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide__control highslide__control--next"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></a>';
			arrowRight.className = 'highslide__control-bar';
		}
		if (arrowLeft.innerHTML != "") {
			sender.createOverlay( { overlayId: arrowLeft, position: "bottom left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
			if (window.innerWidth >= 992) {
				sender.createOverlay( { overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
			};
		}
		if (arrowRight.innerHTML != "") {
			sender.createOverlay( { overlayId: arrowRight, position: "bottom right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
			if (window.innerWidth >= 992) {
				sender.createOverlay( { overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
			};
		}
		if (closeBtn.innerHTML != "") {
			sender.createOverlay( { overlayId: closeBtn, position: "bottom center", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport', useOnHtml: true } );
			if (window.innerWidth >= 992) {
				sender.createOverlay( { overlayId: closeBtn, position: "top right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport', useOnHtml: true } );
			};
		}
	};
};

hs.Expander.prototype.onAfterExpand = function(sender) {
	$('body').css('overflow-y', 'hidden');
	$('iframe').contents().find('html').addClass('is-highslide');

};

hs.Expander.prototype.onAfterClose = function(sender) {

	$('body').css('overflow-y', 'auto');

	if (sender.custom && sender.custom.puUrl && sender.custom.puWidget) {
		executePartialUpdate(sender.custom.puUrl, sender.custom.puWidget);
	}
};

$( window ).on('resize', function() {
	if (window.innerWidth >= 992) {
		hs.marginBottom = 80;
		hs.marginLeft = 120;
		hs.marginRight = 120;
		hs.marginTop = 80;
	} else {
		hs.marginBottom = 90;
		hs.marginLeft = 30;
		hs.marginRight = 30;
		hs.marginTop = 30;
	};
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/highslide-settings.js